import axios from 'axios'
import store from '@/store'
import router from '@/router'
import { ADD_USER_MESSAGES, SCHEDULING_SET_PARAMETERS } from '@/store/action-types'
import { UserMessage } from '@/model/messaging/UserMessage'
import { SET_CURRENT_USER } from '@/store/mutation-types'

function addDefaultHeadersInterceptor (config: any): any {
  config.headers.get['Accept'] = 'application/json'

  if (store.state.currentUser) {
    config.headers.get['Authorization'] = store.state.currentUser.authorizationHeaderValue
    config.headers.post['Authorization'] = store.state.currentUser.authorizationHeaderValue
    config.headers.put['Authorization'] = store.state.currentUser.authorizationHeaderValue
    config.headers.delete['Authorization'] = store.state.currentUser.authorizationHeaderValue
  }
  return config
}

const config = {
  baseURL: process.env.VUE_APP_API_ROOT
}

const instance = axios.create(config)

instance.interceptors.request.use(addDefaultHeadersInterceptor)

instance.interceptors.response.use(function (response) {

  if(response && response.data && response.data.HasUserMessages) {
    store.dispatch(ADD_USER_MESSAGES, UserMessage.createListFromResponse(response.data.UserMessages))
  }

  return response
}, function (error) {
  if (error.response.status === 401) {
    store.dispatch(SCHEDULING_SET_PARAMETERS, undefined)
    store.dispatch(SET_CURRENT_USER, undefined)
    localStorage.removeItem('token')
    router.push('/login')
  }
  return Promise.reject(error)
})

export default instance
